/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-06-28
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Row } from 'reactstrap';
import Header from 'components/support/layout/Header';
import Main from 'components/support/layout/MainContainer';
import { Sidebar, SidebarComplement, SidebarNavLink } from 'components/support/layout/Sidebar';
import Page from 'components/support/layout/Page';
import OrganizationsSection from './sections/Organizations';
import UsersSection from './sections/Users';

type Props = {
  match: {
    path: string,
    url: string,
  },
};

const AdminPage = ({ match }: Props) => (
  <Page className="admin-page">
    <Header />
    <Main>
      <Row>
        <Sidebar>
          <SidebarNavLink to={`${match.url}/organizations`}>
            Organizations
          </SidebarNavLink>
          <SidebarNavLink to={`${match.url}/user`}>
            Users
          </SidebarNavLink>
        </Sidebar>
        <SidebarComplement>
          <Switch>
            <Route path={`${match.path}/organization`} component={OrganizationsSection} />
            <Route path={`${match.path}/user`} component={UsersSection} />
            <Redirect to={`${match.url}/organization`} />
          </Switch>
        </SidebarComplement>
      </Row>
    </Main>
  </Page>
);

export default AdminPage;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/index.jsx